import Vue from 'vue'
import Vuex from 'vuex'
import serviceRoute from '../service-routes'
import VuexPersistence from 'vuex-persist'
const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
  key: 'raw_data',
  reducer: (state) => {
    return {
      token: state.token,
      userId: state.userId,
      username: state.username,
      password: state.password,
      role: state.role,
      isAuth: state.isAuth,
      accountId: state.accountId,
      accounts: state.accounts,
      undoHistory: {},
      userStatus: state.userInfo ? state.userInfo.status : null,
      isShowExportHistory: state.isShowExportHistory,
      taskFilter: state.taskFilter,
      editorFilter: state.editorFilter
    }
  }
})

Vue.use(Vuex)
const initState = {
  userInfo: null,
  token: null,
  undoHistory: {},
  userTagging: [],
  onlineUsers: [],
  isAuth: false,
  role: null,
  userId: null,
  username: null,
  password: null,
  rawData: {},
  chunkData: [],
  duplicateData: null,
  errorMsg: '',
  saveData: null,
  chunkDataUpdate: null,
  accounts: [],
  accountId: null,
  chunkFilter: {},
  exportHistoryData: [],
  isShowExportHistory: true,
  taskFilter: {},
  editorFilter: []
}
export default new Vuex.Store({
  state: Object.assign({}, initState),
  getters: {
    editorFilter(state) {
      return state.editorFilter
    },
    taskFilter(state) {
      return state.taskFilter
    },
    isAdmin(state) {
      return state.role === 'admin'
    },
    isShowExportHistory(state) {
      return state.isShowExportHistory
    },
    exportHistoryData(state) {
      return state.exportHistoryData
    },
    userStatus(state) {
      return state.userInfo.status
    },
    undoHistory(state) {
      return (chunkId) => {
        return state.undoHistory[chunkId] || []
      }
    },
    userTagging(state) {
      return state.userTagging
    },
    onlineUsers(state) {
      return state.onlineUsers
    },
    chunkFilter(state) {
      return state.chunkFilter
    },
    accountId(state) {
      return state.accountId
    },
    accounts(state) {
      return state.accounts
    },
    role(state) {
      return state.role
    },
    isAuth(state) {
      return state.isAuth
    },
    userId(state) {
      return state.userId
    },
    username(state) {
      return state.username
    },
    password(state) {
      return state.password
    },
    errorMsg(state) {
      return state.errorMsg
    },
    chunkData(state) {
      return state.chunkData
    },
    rawData(state) {
      return state.rawData
    },
    duplicateData(state) {
      return state.duplicateData
    },
    saveData(state) {
      return state.saveData
    },
    chunkDataUpdate(state) {
      return state.chunkDataUpdate
    },
    token(state) {
      return state.token
    }
  },
  actions: {
    setTaskFilter(context, data) {
      context.commit('setTaskFilter', data)
    },
    setEditorFilter(context, data) {
      context.commit('setEditorFilter', data)
    },
    async clearExportHistory(context, { ids }) {
      await serviceRoute.clearVisibleExportQueue(ids).catch()
      context.dispatch('showExportHistory')
    },
    showExportHistory(context, isShow) {
      context.commit('setShowExportHistory', isShow)
    },
    async loadExportHistory(context) {
      let res = await serviceRoute.getExportHistory({
        configId: context.state.accountId
      })
      context.commit('setExportHistory', res.data)
    },
    setUserInfo(context, data) {
      context.commit('setUserInfo', data)
    },
    setToken(context, data) {
      context.commit('setToken', data)
    },
    setUndoHistory(context, history) {
      // {chunkId : [{}]}
      context.commit('setUndoHistory', history)
    },
    setUserTagging(context, data) {
      context.commit('setUserTagging', data)
    },
    setOnlineUsers(context, data) {
      context.commit('setOnlineUsers', data)
    },
    setChunkFilter(context, data) {
      context.commit('setChunkFilter', data)
    },
    setPassword(context, password) {
      context.commit('setPassword', password)
    },
    setUserId(context, userId) {
      context.commit('setUserId', userId)
    },
    setUsername(context, username) {
      context.commit('setUsername', username)
    },
    setErrorMsg(context, message) {
      context.commit('setErrorMsg', message)
    },
    setIsAuth(context, isAuth) {
      context.commit('setIsAuth', isAuth)
    },
    setRole(context, role) {
      context.commit('setRole', role)
    },
    async auth(context, data) {
      return serviceRoute.auth(data)
    },
    async getRawData(context, id) {
      context.commit('setRawData', {})
      const responseData = await serviceRoute.getData(id)
      context.commit('setRawData', responseData)
    },

    async getChunkData(context, data) {
      let responseData = await serviceRoute.getChunkData(data)
      if (!responseData.error) {
        context.commit('setChunkData', responseData.data.data)
      }
    },
    async updateChunkData(context, data) {
      return new Promise(async (resolve) => {
        let responseData = await serviceRoute.updateChunkData(
          data.chunkId,
          data
        )
        if (!responseData.error) {
          context.commit('setUpdateChunkData', responseData)
        }
        resolve(responseData)
      })
    },
    async updateRecords(context, data) {
      await serviceRoute.updateRecords(data.chunkId, data.records)
    },
    async getUsers(context) {
      let users = await serviceRoute.getUsers()
      return users.data
    },
    async duplicateRecord(context, data) {
      const responseData = await serviceRoute.duplicateRecord(
        data.chunkId,
        data._id
      )
      context.commit('setDuplicateRecord', responseData)
    },
    async deleteRecord(context, data) {
      const responseData = await serviceRoute.deleteRecord(
        data.chunkId,
        data._id
      )
      const isDeleted = responseData.data
      return isDeleted
    },
    async saveRecords(context, data) {
      const responseData = await serviceRoute.saveRecords(
        data.chunkId,
        data.records
      )
      context.commit('setSaveRecords', responseData)
    },
    async exportByDate(context, data) {
      return serviceRoute.exportExcel(data)
    },
    async exportByChunkId(context, data) {
      return serviceRoute.exportExcel(data)
    },
    async getAccounts(context, data) {
      let response = await serviceRoute.getAccounts()
      context.commit('setAccounts', response.data || [])
    },
    async getExportHistory(context, data) {
      let history = await serviceRoute.getExportHistory(data)
      return history.data
    },
    setAccountId(context, accountId) {
      context.commit('setAccountId', accountId)
    },
    resetState(context) {
      context.commit('resetState')
    },
    async createUser(context, data) {
      let responseData = await serviceRoute.createUser(data)
      return responseData.data
    },
    async deleteUser(context, accountId) {
      await serviceRoute.deleteUser(accountId)
    },
    async updateUser(context, data) {
      let responseData = await serviceRoute.updateMe(data)
      return responseData.data
    },
    async changePassword(context, data) {
      let responseData = await serviceRoute.changePassword(data)
      return responseData.data
    },
    async getAccountConfig(context, data) {
      let result = await serviceRoute.getAccountConfig(this.state.accountId)
      return result
    }
  },
  mutations: {
    setTaskFilter(state, data) {
      state.taskFilter = {
        ...state.taskFilter,
        ...JSON.parse(JSON.stringify(data))
      }
    },
    setEditorFilter(state, data) {
      state.editorFilter = data
    },
    setShowExportHistory(state, isShow) {
      state.isShowExportHistory = isShow
    },
    setExportHistory(state, history) {
      state.exportHistoryData = history
    },
    setUserInfo(state, userInfo) {
      state.userInfo = userInfo
    },
    setToken(state, token) {
      state.token = token
    },
    setUndoHistory(state, history) {
      state.undoHistory = history
    },
    setOnlineUsers(state, data) {
      state.onlineUsers = data
    },
    setUserTagging(state, data) {
      state.userTagging = data
    },
    resetState(state) {
      Object.assign(state, initState)
    },
    setChunkFilter(state, chunkFilter) {
      state.chunkFilter = chunkFilter
    },
    setAccountId(state, accountId) {
      state.accountId = accountId
    },
    setIsAuth(state, isAuth) {
      state.isAuth = isAuth
    },
    setRole(state, role) {
      state.role = role
    },
    setErrorMsg(state, errorMsg) {
      state.errorMsg = errorMsg
    },
    setPassword(state, password) {
      state.password = password || null
    },
    setUserId(state, userId) {
      state.userId = userId
    },
    setUsername(state, username) {
      state.username = username || null
    },
    setRawData(state, data) {
      state.rawData = data || {}
    },
    setChunkData(state, data) {
      state.chunkData = data.data
    },
    setDuplicateRecord(state, data) {
      state.duplicateData = data.data
    },
    setSaveRecords(state, data) {
      state.saveData = data.data
    },
    setUpdateChunkData(state, data) {
      if (Object.keys(state.rawData).length) {
        state.rawData.detail.status = data.status
      }
    },
    setAccounts(state, accounts) {
      state.accounts = accounts
    }
  },
  modules: {},
  plugins: [vuexLocal.plugin]
})
